import React from 'react';

import { autocompletion } from '@codemirror/autocomplete';
import { sql } from '@codemirror/lang-sql';
import CodeMirror from '@uiw/react-codemirror';

import { logger } from '@/utils/logger';

import { useNodeNames } from '../../context/node-names.context';
import { keywords, snippets } from './data/sparql-autocompletions';

const customSparqlKeywords = [...keywords, ...snippets];

function sparqlCompletion(context) {
  // let word = context.matchBefore(/[\w:.-]+/);
  const word = context.matchBefore(/\w*/);

  const wordLower = (word?.text || '').toLowerCase();
  const from = word?.from || context.pos;

  const sparqlOptions = customSparqlKeywords.filter((option) =>
    option.label.toLowerCase().startsWith(wordLower)
  );

  return {
    from,
    options: sparqlOptions,
  };
}

export const SparqlEditor = ({ value, onChange, defaultValue, disabled, height = '200px' }) => {
  const { getAllNodeNames } = useNodeNames();
  const nodeNames = getAllNodeNames();

  const nodeNamesCompletion = nodeNames.map((name) => ({
    label: name,
    type: 'variable',
  }));

  function combinedCompletion(context) {
    const word = context.matchBefore(/[\w:.-]+/);
    const wordLower = word?.text?.toLowerCase() || '';
    const from = word?.from || context.pos;

    let sparqlSuggestions = null;

    try {
      sparqlSuggestions = sparqlCompletion(context);
    } catch (e) {
      logger.warn('SPARQL completion error:', e);
    }

    const filteredNodeNames = nodeNamesCompletion.filter(
      (option) => !wordLower || option.label.toLowerCase().startsWith(wordLower)
    );
    if (
      wordLower !== '' &&
      !context.explicit &&
      !sparqlSuggestions?.options?.length &&
      !filteredNodeNames.length
    ) {
      return null;
    }
    const fromPos = word?.from === 0 ? 0 : from;

    return {
      from: fromPos,
      options: [...(sparqlSuggestions?.options || []), ...filteredNodeNames],
    };
  }

  return (
    <CodeMirror
      readOnly={disabled}
      value={value || defaultValue || ''}
      height={height}
      extensions={[
        sql(),
        autocompletion({
          override: [combinedCompletion],
          defaultKeymap: true,
          maxRenderedOptions: 100,
          icons: true,
        }),
      ]}
      onChange={onChange}
      theme="light"
      basicSetup={{
        lineNumbers: true,
        highlightActiveLine: true,
        highlightSelectionMatches: true,
        autocompletion: true,
        syntaxHighlighting: true,
        history: true,
      }}
    />
  );
};
